import PhonenumberInput from "@Components/PhonenumberInput/PhonenumberInput";
import { Input } from "antd";
import { Rule } from "antd/es/form";
import { ReactNode } from "react";
import i18n from "src/i18n";

export type FieldType = "string" | "phone" | "email";

const REQUIRED_RULE: Rule = {
  required: true,
  get message() {
    return i18n.t("Topup.fieldRequired");
  },
};

type FieldTypeConfig = {
  component: (displayName: string) => ReactNode;
  rules?: Rule[];
};

const FIELD_TYPE_MAP: Record<FieldType, FieldTypeConfig> = {
  string: {
    component: (displayName) => <Input placeholder={i18n.t("Topup.fieldPlaceholder", { field: displayName })} className="p-3!"/>,
  },
  phone: {
    component: (displayName) => (
      <PhonenumberInput
        initialDialCode="+20"
        selectProps={{ disabled: true }}
        inputProps={{ placeholder: i18n.t("Topup.fieldPlaceholder", { field: displayName }) }}
      />
    ),
    rules: [
      {
        pattern: /^\+?[0-9\s\-().]{7,11}$/,
        get message() {
          return i18n.t("Topup.validPhoneNumber");
        },
      },
    ],
  },
  email: {
    component: (displayName) => <Input placeholder={i18n.t("Topup.fieldPlaceholder", { field: displayName })} className="p-3!"/>,
    rules: [
      {
        type: "email",
        get message() {
          return i18n.t("Topup.validEmail");
        },
      },
    ],
  },
};

export const getFieldConfig = (type: string) => {
  const { component, rules } = FIELD_TYPE_MAP[type as FieldType] ?? FIELD_TYPE_MAP.string;
  return { component, rules: [REQUIRED_RULE, ...(rules ?? [])] };
};

export default FIELD_TYPE_MAP;
